var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIotAndIndustrialIot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iot_And_Industrial_Iot",
    "data-name": "Iot And Industrial Iot",
    transform: "translate(0.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 88,
    cy: 88,
    r: 88,
    transform: "translate(-0.433)",
    fill: "rgba(214,233,255,0.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10638",
    "data-name": "Group 10638",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10637",
    "data-name": "Group 10637"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(-0.433)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "settings_input_component_black_24dp",
    transform: "translate(52.567 53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M0,0H69.944V69.944H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M26.315,19.829a2.914,2.914,0,0,0,5.829,0V14H26.315ZM3,19.829a2.914,2.914,0,0,0,5.829,0V14H3Zm46.629,0a2.914,2.914,0,0,0,5.829,0V14H49.629Z",
    transform: "translate(5.743 26.801)",
    fill: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M12.657,3.914a2.914,2.914,0,0,0-5.829,0V15.572H1V44.715a8.773,8.773,0,0,0,5.829,8.218V65.115h5.829V52.933a8.773,8.773,0,0,0,5.829-8.218V15.572H12.657Zm0,40.8a2.914,2.914,0,0,1-5.829,0V38.886h5.829Zm0-11.657H6.829V21.4h5.829ZM35.972,3.914a2.914,2.914,0,0,0-5.829,0V15.572H24.315V44.715a8.773,8.773,0,0,0,5.829,8.218V65.115h5.829V52.933A8.773,8.773,0,0,0,41.8,44.715V15.572H35.972Zm0,40.8a2.914,2.914,0,0,1-5.829,0V38.886h5.829Zm0-11.657H30.143V21.4h5.829ZM59.287,15.572V3.914a2.914,2.914,0,0,0-5.829,0V15.572H47.629V44.715a8.773,8.773,0,0,0,5.829,8.218V65.115h5.829V52.933a8.773,8.773,0,0,0,5.829-8.218V15.572Zm0,29.143a2.914,2.914,0,0,1-5.829,0V38.886h5.829Zm0-11.657H53.458V21.4h5.829Z",
    transform: "translate(1.914 1.914)",
    fill: "#12355f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotAndIndustrialIot);
export default __webpack_public_path__ + "static/media/Iot And Industrial Iot.e79a7441d59b0722247f41440f284c26.svg";
export { ForwardRef as ReactComponent };